// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/animations.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/blocks.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/code.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/collab.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/lists.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/placeholder.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/table.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./partials/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  caret-color: black;
  outline: none;
  padding: 1rem;
  position: relative;
  z-index: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
}

.ProseMirror .selection {
  display: inline;
}

.ProseMirror .selection,
.ProseMirror *::selection {
  background-color: var(--primary-light, rgba(0, 0, 0, 0.1)); /* bg-black/10 */
  display: inline;
}

.ProseMirror > .react-renderer {
  margin-top: 3rem; /* my-12 */
  margin-bottom: 3rem;
}

.ProseMirror > .react-renderer:first-of-type {
  margin-top: 0; /* first:mt-0 */
}

.ProseMirror > .react-renderer:last-of-type {
  margin-bottom: 0; /* last:mb-0 */
}

.ProseMirror.resize-cursor {
  cursor: col-resize;
}

.ProseMirror .ProseMirror-gapcursor {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.ProseMirror .ProseMirror-gapcursor:after {
  content: "";
  border-top: 1px solid rgba(0, 0, 0, 0.4); /* border-t-black/40 */
  width: 100%;
  position: absolute;
  top: -1.5em;
  left: 0;
  right: 0;
}

[data-theme="slash-command"] {
  width: 1000vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/index.css"],"names":[],"mappings":"AASA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,0DAA0D,EAAE,gBAAgB;EAC5E,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,UAAU;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,eAAe;AAChC;;AAEA;EACE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wCAAwC,EAAE,sBAAsB;EAChE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import \"./partials/animations.css\";\n@import \"./partials/blocks.css\";\n@import \"./partials/code.css\";\n@import \"./partials/collab.css\";\n@import \"./partials/lists.css\";\n@import \"./partials/placeholder.css\";\n@import \"./partials/table.css\";\n@import \"./partials/typography.css\";\n\n.ProseMirror {\n  caret-color: black;\n  outline: none;\n  padding: 1rem;\n  position: relative;\n  z-index: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n}\n\n.ProseMirror .selection {\n  display: inline;\n}\n\n.ProseMirror .selection,\n.ProseMirror *::selection {\n  background-color: var(--primary-light, rgba(0, 0, 0, 0.1)); /* bg-black/10 */\n  display: inline;\n}\n\n.ProseMirror > .react-renderer {\n  margin-top: 3rem; /* my-12 */\n  margin-bottom: 3rem;\n}\n\n.ProseMirror > .react-renderer:first-of-type {\n  margin-top: 0; /* first:mt-0 */\n}\n\n.ProseMirror > .react-renderer:last-of-type {\n  margin-bottom: 0; /* last:mb-0 */\n}\n\n.ProseMirror.resize-cursor {\n  cursor: col-resize;\n}\n\n.ProseMirror .ProseMirror-gapcursor {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ProseMirror .ProseMirror-gapcursor:after {\n  content: \"\";\n  border-top: 1px solid rgba(0, 0, 0, 0.4); /* border-t-black/40 */\n  width: 100%;\n  position: absolute;\n  top: -1.5em;\n  left: 0;\n  right: 0;\n}\n\n[data-theme=\"slash-command\"] {\n  width: 1000vw;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
